import { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { Table, TableColumnsType, TableColumnType, type TableProps, SelectProps, Input, Button, Space, InputRef, message, Modal, Tag, Spin, notification, Progress } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import type { FilterDropdownProps } from 'antd/es/table/interface';
import Highlighter from 'react-highlight-words';
import { fetchUserByKodeGrup1 } from '../utils/sales';
import axios from 'axios';
import { Form } from 'antd';
import { fetchCustomerList } from '../utils/customer_master';
import { AddLineFormData } from './hoc_sales_add_line';
import dayjs from 'dayjs';
import { useAuth } from '../context/AuthContext';
import { useLocation } from 'react-router-dom';
import { isEqual, debounce } from 'lodash';
import useSWR from 'swr';
function StartLicense(stimulsoftInstance: any) {
    const key = process.env.REACT_APP_STIMULSOFT_LICENSE_KEY;
    if (key && key.trim() !== "") {
        try {
            stimulsoftInstance.Base.StiLicense.key = key.trim();
        } catch (error: any) { }
    } else {
        const hardcodedKey = "6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHmKmIYtQbGVffUafn4grxXukjNz+mLI/d2lO8A9DuHxAxu4MmrN4lqhtklB0Pcnfq+AIk+1s6kU0D6JIIxpfQs1FV6pzwrzAWDLexRPvVgpswR/C5n69gFjFmWmtV0bGCTAj6H/MHgwElWYT9nYccmuFH0sfAj7VELa2HehqREJ7di+05AWeWIScfcWsf0XZ3JK+2X3reYvhUEAxrCwX3FDw2p1hPQIfiUVkUd4NRvfwWBLOjP2ZTfp9dzNe1D6T7miK1VBd731o/ex6q1bkdNH+G1KV6OLxdQwb9zWr4AR0QtMKwrphskgAYb5PMCectoVCeRFKtWSm8qnMP+GN8v0GHbJGQ/ZYWMAsE94nCEhnJz9T/xfy1b6WEWqpUUjVsfPzm/naRz0bxVN+AtFW7thTBMwGXoKTJXnKhfrI5u/fRffUu78ejnazBjWCHANN/xF7XOLhnFWw5JZHPXkaoCbiG8kBL3bgL4DtSyZ7jecAPmJUtainwLNMdo75J6hvu/pS+jDUs2tqRjEv6PTehXg";
        try {
            stimulsoftInstance.Base.StiLicense.key = hardcodedKey;
        } catch (fallbackError: any) { }
    }
}

export interface SalesMasterData {
    id: any;
    key?: string | number;
    flag1: string;
    status_part: string;
    so_no: string;
    se_no: string;
    pr_no: string;
    item_code: string;
    item_name: string;
    subs: string;
    uom: string;
    dmd: number;
    sup: number;
    available_qty: number;
    price: number;
    original_disc_percent: number;
    original_disc_amount: number;
    proposal_disc_percent: number;
    proposal_disc_amount: number;
    total: number;
    chassis_no: string;
    regional_stock: string;
    location_code_rack: string;
    remark_table: string;
    invoice_return_no: string;
    warehouse_group?: string;
    uom_rate?: number;
}
interface DealerName {
    id: number;
    code: string;
    deskripsi: string;
}
interface DeliverVia {
    id: number;
    code: string;
    deskripsi: string;
}
interface OutstandingRemark {
    id: number;
    code: string;
    deskripsi: string;
}
interface Top {
    id: number;
    code: string;
    deskripsi: string;
}
interface OrderType {
    id: number;
    code: string;
    deskripsi: string;
}
interface TransactionType {
    id: number;
    code: string;
    deskripsi: string;
}

interface Provinsi {
    kode_provinsi: string;
    nama_provinsi: string;
}

interface Kabupaten {
    kode_dati: string;
    deskripsi_kode_dati: string;
}

interface Kecamatan {
    kode_kecamatan: string;
    deskripsi_kode_kecamatan: string;
}

interface Kelurahan {
    kode_kelurahan: string;
    deskripsi_kode_kelurahan: string;
}

interface SalesGenerateNo {
    id: number;
    code: string;
    deskripsi: string;
    status: string;
}
interface VoidResponse {
    success: boolean;
    message?: string;
}

interface AgreementData {
    id: number;
    no_agreement: string;
    cs_code: string;
    name_customer: string;
    reference_no: string;
    disc: number;
    expired: string;
}
interface WarehouseData {
    id: number;
    warehouse_code: string;
    warehouse_name: string;
}


export const useSalesEstimation = (propsEditData?: any) => {
    const location = useLocation();
    const editDataFromState = propsEditData || location.state?.editData;
    const isInitialLoadRef = useRef(!!editDataFromState)
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [isCheckedCustomerDetail, setIsCheckedCustomerDetail] = useState(false);
    const [isCheckedSameID, setIsCheckedSameID] = useState(false);
    const [deliverVia, setDeliverVia] = useState<string>('');
    const [outstandingRemark, setOutstandingRemark] = useState<string>('');
    const [warehouseGroup, setWarehouseGroup] = useState<string>('');
    const [orderType, setOrderType] = useState<string>('');
    const [Top, setTop] = useState<string>('');
    const [transType, setTransType] = useState<string>('');
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef<InputRef>(null);
    const [form] = Form.useForm();
    const [isCustomerModalVisible, setIsCustomerModalVisible] = useState(false);
    const [customerData, setCustomerData] = useState<any>(null);
    const [shouldUpdateFields, setShouldUpdateFields] = useState(false);
    const [isAddLineModalVisible, setIsAddLineModalVisible] = useState(false);
    const [editingData, setEditingData] = useState<AddLineFormData | null>(null);
    const [addLineModalKey, setAddLineModalKey] = useState(0);
    const [status, setStatus] = useState<string>('');
    const statusValue = form.getFieldValue('status');
    const isEditMode = statusValue && statusValue !== 'Draft';
    const [subTotal, setSubTotal] = useState(0);
    const [itemDisc, setItemDisc] = useState(0);
    const [total, setTotal] = useState(0);
    const [grandTotal, setGrandTotal] = useState<number>(0);
    const [isReadyButtonDisabled, setIsReadyButtonDisabled] = useState(false);
    const [isNotAvailableButtonDisabled, setIsNotAvailableButtonDisabled] = useState(true);
    const { userData } = useAuth();
    const [isCloseOrderModalVisible, setIsCloseOrderModalVisible] = useState(false);
    const [isAgreementModalVisible, setIsAgreementModalVisible] = useState(false);
    const [isSubmitModalVisible, setIsSubmitModalVisible] = useState(false);
    const [submitRemark, setSubmitRemark] = useState('');
    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const [isActuallyEditing, setIsActuallyEditing] = useState(false);
    const [currentAgreementDisc, setCurrentAgreementDisc] = useState<number | undefined>(undefined);
    const [tableData, setTableData] = useState<SalesMasterData[]>([]);
    const [isLockItemDisabled, setIsLockItemDisabled] = useState(true);
    const [isAutosaveEnabled, setIsAutosaveEnabled] = useState(false);
    const [autosaveStatus, setAutosaveStatus] = useState<'idle' | 'processing' | 'error' | 'stopped'>('idle');
    const [isPrintButtonDisabled, setIsPrintButtonDisabled] = useState(true);
    const [isPrinting, setIsPrinting] = useState(false);
    const handleReportModalCancel = () => setIsReportModalOpen(false);
    const [isReportModalOpen, setIsReportModalOpen] = useState(false);
    const statusWatch = Form.useWatch('status', form);
    const seNoWatch = Form.useWatch('se_no', form);
    const orderTypeWatch = Form.useWatch('order_type', form);
    const csCodeWatch = Form.useWatch('cs_code', form);
    const agreementNoWatch = Form.useWatch('agreement_no', form);
    const topWatch = Form.useWatch('top', form);
    const grandTotalWatch = Form.useWatch('grand_total', form);
    const creditLimitWatch = Form.useWatch('credit_limit_remaining', form);
    const [ppn, setPpn] = useState<number>(0);

    const fetcher = async (url: string) => {
        const res = await fetch(`${backendUrl}${url}`);
        if (!res.ok) {
            const error = new Error('An error occurred while fetching the data.');
            // @ts-ignore
            error.info = await res.json();
            // @ts-ignore
            error.status = res.status;
            throw error;
        }
        return res.json();
    };

    const { data: swrTableData, error: tableDataError, isLoading: isLoadingTableData } = useSWR<SalesMasterData[]>(seNoWatch ? `/api/sales-master?se_no=${seNoWatch}` : null, fetcher, { revalidateOnFocus: false, revalidateOnReconnect: false });
    useEffect(() => {
        if (swrTableData) {
            const mapped = swrTableData.map(item => ({ ...item, key: item.id, sup: Number(item.sup) || 0 }));
            setTableData(mapped);
            isInitialLoadRef.current = false;
        } else if (!seNoWatch) {
            setTableData([]);
        }
    }, [swrTableData, seNoWatch]);

    const { data: metaData, error: metaError, isLoading: isLoadingMeta } = useSWR<any>('/api/sales-estimation-metadata', fetcher, { revalidateOnFocus: false, revalidateOnReconnect: false });
    const warehouseData: WarehouseData[] = metaData?.warehouse || [];
    const deliverViaData: DeliverVia[] = metaData?.deliverVia || [];
    const outstandingRemarkData: OutstandingRemark[] = metaData?.outstandingRemark || [];
    const topData: Top[] = metaData?.top || [];
    const orderTypeData: OrderType[] = metaData?.orderType || [];
    const transactionTypeData: TransactionType[] = metaData?.transactionType || [];
    const provinsiData: Provinsi[] = metaData?.provinsi || [];
    const kabupatenData: Kabupaten[] = metaData?.kabupaten || [];
    const kecamatanData: Kecamatan[] = metaData?.kecamatan || [];
    const kelurahanData: Kelurahan[] = metaData?.kelurahan || [];


    useEffect(() => {
        if (metaData?.ppn !== undefined) {
            setPpn(metaData.ppn);
        }
    }, [metaData]);

    useEffect(() => {
        if (userData?.warehouse_code && !isActuallyEditing && !form.getFieldValue('warehouse_group')) {
            form.setFieldsValue({ warehouse_group: userData.warehouse_code });
            setWarehouseGroup(userData.warehouse_code);
        }
    }, [userData, isActuallyEditing, form]);

    const loading = (isInitialLoadRef.current && isLoadingTableData);
    const error = metaError || tableDataError;
    const handleAgreementSelect = (agreementNo: string) => {
        form.setFieldsValue({ agreement_no: agreementNo });
        handleAgreementModalClose();
    };

    const fetchDiscFromAgreement = async (agreementNo: string): Promise<number | undefined> => {
        try {
            const response = await fetch(`${backendUrl}/api/agreement-data?no_agreement=${encodeURIComponent(agreementNo)}`);
            if (!response.ok) {
                console.error('Failed to fetch agreement data');
                return undefined;
            }
            const result = await response.json();
            if (result.data && result.data.length > 0) {
                return result.data[0].disc;
            }
            return undefined;
        } catch (error) {
            console.error('Error fetching disc from agreement:', error);
            return undefined;
        }
    };

    useEffect(() => {
        const loadAgreementDisc = async () => {
            const agreementNo = agreementNoWatch;
            if (agreementNo) {
                const disc = await fetchDiscFromAgreement(agreementNo);
                setCurrentAgreementDisc(disc);
                form.setFieldsValue({ disc_agreement: disc });
            } else {
                setCurrentAgreementDisc(undefined);
                form.setFieldsValue({ disc_agreement: undefined });
            }
        };
        loadAgreementDisc();

    }, [form, backendUrl, setCurrentAgreementDisc, agreementNoWatch]);


    const handleVoid = async () => {
        if (autosaveStatus === 'processing') return;
        try {
            const seNo = form.getFieldValue('se_no');
            if (!seNo) {
                notification.error({ message: 'Error', description: 'SE Number tidak ditemukan' });
                return;
            }

            const response = await fetch(`${backendUrl}/api/void-sales-order`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                },
                body: JSON.stringify({ se_no: seNo })
            });

            if (!response.ok) throw new Error('Void gagal');

            notification.success({ message: 'Sukses', description: 'Sukses! Draft SE telah di canceled' });
            form.setFieldsValue({ status: '05' });
            handleNew();
        } catch (error) {
            console.error('Void error:', error);
            notification.error({ message: 'Error', description: 'Gagal melakukan Void SE' });
        }
    };

    const handleSubmit = async () => {
        if (autosaveStatus === 'processing') return;
        try {
            await form.validateFields();
            const seNo = form.getFieldValue('se_no');
            if (!seNo) {
                notification.error({ message: 'Error', description: 'SE Number tidak ditemukan' });
                return;
            }

            setSubmitRemark('');
            setIsSubmitModalVisible(true);
        } catch (errorInfo) {
            console.log('Submit/Validation failed:', errorInfo);
            if (!(errorInfo && (errorInfo as any).errorFields)) {
                notification.error({ message: 'Error', description: 'Gagal submit SE 404 Not Registered' });
            }
        }
    };

    const handleConfirmSubmit = async () => {
        try {
            const seNo = form.getFieldValue('se_no');
            const response = await fetch(`${backendUrl}/api/submit-sales-order`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                },
                body: JSON.stringify({ se_no: seNo, remark: submitRemark })
            });
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.error || 'Submit gagal');
            }
            form.setFieldsValue({ status: '03' });
            notification.success({ message: 'Sukses', description: 'SE telah di submit, mohon tunggu di approve' });
            setIsSubmitModalVisible(false);
            handleNew();
        } catch (error: any) {
            console.error('Submit failed:', error);
            notification.error({ message: 'Error', description: error.message || 'Gagal submit SE' });
        }
    };

    const handleSubmitModalClose = () => {
        setIsSubmitModalVisible(false);
    };

    const isCloseOrderDisabled = () => {
        const currentStatus = form.getFieldValue('status');
        return autosaveStatus === 'processing' || !(currentStatus === '02' || currentStatus === 'Approved');
    };

    const isSubmitDisabled = () => {
        const currentStatus = form.getFieldValue('status');
        if (autosaveStatus === 'processing') return true;
        return ['Approved', 'Waiting for Approved', 'Close / Complete', 'Canceled', 'Closed'].includes(currentStatus);
    };

    const isVoidDisabled = () => {
        const currentStatus = form.getFieldValue('status');
        if (autosaveStatus === 'processing') return true;
        return ['Approved', 'Waiting for Approved', 'Close / Complete', 'Canceled', 'Closed'].includes(currentStatus);
    };

    const handleCloseOrderModalOpen = () => {
        if (autosaveStatus === 'processing') return;
        setIsCloseOrderModalVisible(true);
    };
    const handleCloseOrderModalClose = () => setIsCloseOrderModalVisible(false);
    const handleAgreementModalOpen = () => setIsAgreementModalVisible(true);
    const handleAgreementModalClose = () => setIsAgreementModalVisible(false);

    const calculateTotals = (data: SalesMasterData[]) => {
        const filteredData = data.filter(item => item.status_part !== '99');
        const newSubTotal = filteredData.reduce((sum, item) => {
            return sum + (Number(item.price || 0) * Number(item.dmd || 0));
        }, 0);
        const newItemDisc = filteredData.reduce((sum, item) => {
            return sum + (Number(item.proposal_disc_amount || 0) * Number(item.dmd || 0)) + (Number(item.original_disc_amount || 0) * Number(item.dmd || 0));
        }, 0)
        const totalBeforePPN = newSubTotal - newItemDisc;
        const newVAT = totalBeforePPN * (ppn / 100);
        const newTotal = totalBeforePPN;
        const newGrandTotal = totalBeforePPN + newVAT;

        setSubTotal(newSubTotal);
        setItemDisc(newItemDisc);
        setTotal(newTotal);
        setGrandTotal(newGrandTotal);

        form.setFieldsValue({
            sub_total: newSubTotal,
            item_disc: newItemDisc,
            vat: newVAT,
            total_a: newTotal,
            grand_total: newGrandTotal,
        });
    };
    useEffect(() => {
        if (tableData && ppn !== undefined) {
            calculateTotals(tableData);
        }
    }, [tableData, ppn]);

    useEffect(() => {
        const timer = setTimeout(() => {
            const csCode = csCodeWatch;
            if (csCode && provinsiData && kabupatenData && kecamatanData && kelurahanData) {
                handleCustomerCodeBlur();
            }
        }, 500);
        return () => clearTimeout(timer);

    }, [form, provinsiData, kabupatenData, kecamatanData, kelurahanData, csCodeWatch]);


    useEffect(() => {
        const statusValue = form.getFieldValue('status');
        setStatus(statusValue);
    }, [form, statusWatch]);


    const isStatus01 = () => !status || status === '01' || status === 'Draft';

    const handleDelete = () => {
        if (selectedRowKeys.length === 0) {
            notification.warning({ message: 'Peringatan', description: 'Please select items to delete' });
            return;
        }

        Modal.confirm({
            title: 'Delete Confirmation',
            content: `Are you sure you want to delete ${selectedRowKeys.length} selected item(s)?`,
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk() {

                const newData = tableData.filter(
                    item => !selectedRowKeys.includes(item.key as React.Key)
                );
                setTableData(newData);
                setSelectedRowKeys([]);
                notification.success({ message: 'Sukses', description: `${selectedRowKeys.length} item(s) deleted successfully` });
            }
        });
    };

    const handleRowDoubleClick = (record: SalesMasterData) => {
        setEditingData({
            item_code: record.item_code,
            item_name: record.item_name,
            subs: record.subs,
            uom: record.uom,
            dmd: record.dmd,
            available_qty: record.available_qty,
            sup: record.sup,
            price: record.price,
            original_disc_percent: record.original_disc_percent,
            original_disc_amount: record.original_disc_amount,
            proposal_disc_percent: record.proposal_disc_percent,
            proposal_disc_amount: record.proposal_disc_amount,
            total: record.total,
            regional_stock: record.regional_stock,
            location_code_rack: record.location_code_rack,
            remark_table: record.remark_table,
        });
        setIsAddLineModalVisible(true);
    };

    const handleAddLineSubmit = async (data: AddLineFormData) => {
        try {
            if (!data.item_code) {
                notification.error({ message: 'Error', description: 'Item Code is required' });
                return;
            }
            const demandQty = Number(data.dmd) || 0;
            const availableQty = Number(data.available_qty) || 0;
            let partStatus: string;

            if (availableQty <= 0) {
                partStatus = '02';
            } else if (demandQty > availableQty) {
                partStatus = '04';
            } else {
                partStatus = '01';
            }
            const warehouseGroupValue = form.getFieldValue('warehouse_group');
            if (editingData) {

                const existingIndex = tableData.findIndex(item => item.item_code === editingData.item_code);

                if (existingIndex === -1) {
                    notification.error({ message: 'Error', description: 'Data not found for updating' });
                    return;
                }

                const newTableData = tableData.map(item =>
                    item.item_code === editingData.item_code ? {
                        ...item,
                        item_code: data.item_code,
                        item_name: data.item_name,
                        subs: data.subs,
                        uom: data.uom,
                        dmd: Number(data.dmd) || 0,
                        sup: Number(data.sup) || 0,
                        available_qty: Number(data.available_qty) || 0,
                        price: Number(data.price) || 0,
                        original_disc_percent: Number(data.original_disc_percent) || 0,
                        original_disc_amount: Number(data.original_disc_amount) || 0,
                        proposal_disc_percent: Number(data.proposal_disc_percent) || 0,
                        proposal_disc_amount: Number(data.proposal_disc_amount) || 0,
                        total: Number(data.total) || 0,
                        regional_stock: data.regional_stock || '',
                        location_code_rack: data.location_code_rack || '',
                        remark_table: data.remark_table || '',
                        status_part: partStatus,
                        warehouse_group: warehouseGroupValue,
                    } : item
                );

                setTableData(newTableData);
                notification.success({ message: 'Sukses', description: 'Data updated successfully' });
            } else {

                if (tableData.some(item => item.item_code === data.item_code)) {
                    notification.error({ message: 'Error', description: 'Item Code already exists' });
                    return;
                }


                const newTableData = [...tableData];
                newTableData.push({
                    id: Date.now(),
                    key: Date.now().toString(),
                    item_code: data.item_code,
                    item_name: data.item_name,
                    subs: data.subs,
                    uom: data.uom,
                    dmd: Number(data.dmd) || 0,
                    sup: Number(data.sup) || 0,
                    available_qty: Number(data.available_qty) || 0,
                    price: Number(data.price) || 0,
                    original_disc_percent: Number(data.original_disc_percent) || 0,
                    original_disc_amount: Number(data.original_disc_amount) || 0,
                    proposal_disc_percent: Number(data.proposal_disc_percent) || 0,
                    proposal_disc_amount: Number(data.proposal_disc_amount) || 0,
                    total: Number(data.total) || 0,
                    regional_stock: data.regional_stock || '',
                    location_code_rack: data.location_code_rack || '',
                    remark_table: data.remark_table || '',
                    flag1: '',
                    status_part: partStatus,
                    so_no: '',
                    se_no: '',
                    pr_no: '',
                    chassis_no: '',
                    invoice_return_no: '',
                    warehouse_group: warehouseGroupValue

                });

                setTableData(newTableData);
                notification.success({ message: 'Sukses', description: 'Data added successfully' });
            }

            handleAddLineModalClose();

        } catch (error) {
            console.error('Error in handleAddLineSubmit:', error);
            notification.error({ message: 'Error', description: 'Failed to process data' });
        }
    };

    const handleAddLineModalOpen = async () => {
        setEditingData(null);
        setAddLineModalKey(prevKey => prevKey + 1);
        setIsAddLineModalVisible(true);
    };
    const handleAddLineModalClose = () => {
        setIsAddLineModalVisible(false);
        setEditingData(null);
    };

    const generateNewSENumber = async () => {
        if (!form.getFieldValue('se_no')) {
            try {
                const response = await fetch(`${backendUrl}/api/generate-se-number`);
                if (!response.ok) throw new Error('Failed to generate SE number');
                const result = await response.json();
                if (result?.seNumber) {
                    form.setFieldsValue({ se_no: result.seNumber });
                }
            } catch (error) {
                console.error('Error generating SE number:', error);
            }
        }
    };


    const handleNew = () => {
        if (autosaveStatus === 'processing') return
        setIsActuallyEditing(false);
        form.resetFields();
        setTableData([]);
        setSelectedRowKeys([]);
        setIsCheckedCustomerDetail(false);
        setIsCheckedSameID(false);
        setDeliverVia('');
        setWarehouseGroup('');
        setOutstandingRemark('');
        setOrderType('');
        setTop('');
        setTransType('');
        setCustomerData(null);
        setEditingData(null);
        setCurrentAgreementDisc(undefined);
        setSubTotal(0);
        setItemDisc(0);
        setTotal(0);
        setGrandTotal(0);
        setAutosaveStatus('idle');

        form.setFieldsValue({
            status: 'Draft',
            sales_date: getCurrentDate().display,
            cs_code: '',
            cs_name: '',
            title_prefix: '',
            customer_name: '',
            title_suffix: '',
            cs_address1: '',
            cs_address2: '',
            cs_provinsi: '',
            cs_kabupaten: '',
            cs_kecamatan: '',
            cs_kelurahan: '',
            cs_kodepos: '',
            cs_phone: '',
            cs_phone1: '',
            cs_npwp: ''
        });
        form.setFieldsValue({
            sales_date: getCurrentDate().display,
        });
        setCurrentAgreementDisc(undefined);
        setIsAutosaveEnabled(true);
    };


    const getStatusText = (statusValue: string): string => {
        switch (statusValue) {
            case '01': return 'Draft';
            case '02': return 'Approved';
            case '03': return 'Waiting for Approved';
            case '04': return 'Close / Complete';
            case '05': return 'Canceled';
            case '06': return 'Closed';
            default: return 'Unknown Status';
        }
    };


    useEffect(() => {
        if (editDataFromState) {
            setIsActuallyEditing(true);
            const parsedData = editDataFromState;
            const convertedData = {
                ...parsedData,
                status: getStatusText(parsedData.status)
            };

            let displaySalesDate: string | null = null;
            if (parsedData.sales_date && typeof parsedData.sales_date === 'string') {
                const d = dayjs(parsedData.sales_date, 'DD/MM/YYYY');
                if (d.isValid()) {
                    displaySalesDate = d.format('DD/MM/YYYY');
                } else {
                    console.warn(`[hoc_sales] editDataFromState.sales_date "${parsedData.sales_date}" tidak valid. Diatur menjadi null.`);
                }
            }

            form.setFieldsValue({
                ...convertedData,
                sales_date: displaySalesDate,
            });
            const fetchSalesPersonName = async () => {
                const salesPersonCode = parsedData.sales_person_code || parsedData.sales_person;

                if (salesPersonCode) {
                    try {
                        const user = await fetchUserByKodeGrup1(salesPersonCode);
                        form.setFieldsValue({
                            sales_person: user?.nama || salesPersonCode
                        });
                    } catch (error) {
                        form.setFieldsValue({ sales_person: salesPersonCode });
                    }
                }
            };
            fetchSalesPersonName();
        } else {
            setIsActuallyEditing(false);
            if (!form.getFieldValue('sales_date')) {
                form.setFieldsValue({
                    sales_date: getCurrentDate().display,
                });
            }
            if (!form.getFieldValue('status')) {
                form.setFieldsValue({ status: 'Draft' });
            }
        }
        setIsAutosaveEnabled(true);
    }, [editDataFromState, form, backendUrl]);

    const lastSavedState = useRef<{ formValues: any, tableData: SalesMasterData[] }>({ formValues: null, tableData: [] });
    const autosave = useCallback(
        async (formValuesToSave: any, tableDataToSave: SalesMasterData[], isCurrentlyEditing: boolean) => {


            if (isEqual(formValuesToSave, lastSavedState.current.formValues) &&
                isEqual(tableDataToSave, lastSavedState.current.tableData)) {
                setAutosaveStatus('idle');
                return;
            }

            const currentSeNo = formValuesToSave.se_no;
            const currentStatus = formValuesToSave.status;
            const currentOrderType = formValuesToSave.order_type;

            if (!currentSeNo || ['Approved', 'Waiting for Approved', 'Close / Complete', 'Canceled', 'Closed'].includes(currentStatus) || !currentOrderType) {
                setAutosaveStatus('stopped');
                return;
            }
            setAutosaveStatus('processing');
            try {
                const values = formValuesToSave;
                let formattedSalesDate = null;
                if (values.sales_date) {
                    const parsedDate = dayjs(values.sales_date, 'DD/MM/YYYY');
                    if (parsedDate.isValid()) {
                        formattedSalesDate = values.sales_date;
                    } else {
                        console.warn(`Warning: sales_date "${values.sales_date}" was not in DD/MM/YYYY format or was invalid. Sending null to backend.`);
                    }
                }
                const kodeGrup1 = userData?.kode_grup1 || "";
                const isUpdateOperationForSave = isCurrentlyEditing;
                let statusCodeToSend = '';
                const statusMap = {
                    'Draft': '01', 'Approved': '02', 'Waiting for Approved': '03',
                    'Close / Complete': '04', 'Canceled': '05', 'Closed': '06'
                };
                statusCodeToSend = statusMap[currentStatus as keyof typeof statusMap] || '01';

                const formData = {
                    isUpdateOperation: isUpdateOperationForSave,
                    flag1: values.flag1 || '',
                    user_approved: values.user_approved || '',
                    sales_person: kodeGrup1 || '',
                    status: statusCodeToSend,
                    se_no: values.se_no || '',
                    sales_date: formattedSalesDate,
                    so_no: values.so_no || '',
                    trans_type: values.trans_type || '',
                    order_type: values.order_type || '',
                    cs_code: values.cs_code || '',
                    cs_name: values.cs_name || '',
                    purchase_order_no: values.purchase_order_no || '',
                    top: values.top || '',
                    agreement_no: values.agreement_no || '',
                    credit_limit_approval_status: values.credit_limit_approval_status || '',
                    sub_total: Number(values.sub_total || 0),
                    item_disc: Number(values.item_disc || 0),
                    total_a: Number(values.total_a || 0),
                    vat: Number(values.vat || 0),
                    grand_total: Number(values.grand_total || 0),
                    delivery_address1: values.delivery_address1 || '',
                    delivery_address2: values.delivery_address2 || '',
                    contact_person: values.contact_person || '',
                    contact_phone: values.contact_phone || '',
                    deliver_via: values.deliver_via || '',
                    warehouse_group: values.warehouse_group || '',
                    approval_remark: values.approval_remark || '',
                    outstanding_remark: values.outstanding_remark || '',
                    remark: values.remark || '',
                    credit_limit_remaining: values.credit_limit_remaining || 0,
                    lineItems: tableDataToSave.map((item: SalesMasterData) => ({
                        id: item.id,
                        item_code: item.item_code,
                        item_name: item.item_name,
                        status_part: item.status_part,
                        pr_no: item.pr_no,
                        subs: item.subs,
                        uom: item.uom,
                        dmd: item.dmd,
                        sup: item.sup,
                        available_qty: item.available_qty,
                        price: item.price,
                        original_disc_percent: item.original_disc_percent,
                        original_disc_amount: item.original_disc_amount,
                        proposal_disc_percent: item.proposal_disc_percent,
                        proposal_disc_amount: item.proposal_disc_amount,
                        total: item.total,
                        regional_stock: item.regional_stock,
                        remark_table: item.remark_table,
                        invoice_return_no: item.invoice_return_no,
                        warehouse_group: item.warehouse_group,
                        location_code_rack: item.location_code_rack
                    }))
                };

                const response = await fetch(`${backendUrl}/api/sales-master`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                    },
                    body: JSON.stringify(formData)
                });

                if (response.ok) {
                    const result = await response.json();
                    if (!isUpdateOperationForSave && result.se_no) {
                        form.setFieldsValue({ se_no: result.se_no });
                        setIsActuallyEditing(true);
                    }
                    setAutosaveStatus('idle');
                    lastSavedState.current = { formValues: formValuesToSave, tableData: tableDataToSave };
                    return result;
                } else if (response.status === 409) {
                    const errorResult = await response.json();
                    if (errorResult.error === 'SE_NUMBER_EXISTS' && errorResult.newSeNumber) {

                        if (!isCurrentlyEditing) {
                            notification.warning({ message: 'Peringatan', description: errorResult.message, duration: 5 });
                            form.setFieldsValue({ se_no: errorResult.newSeNumber });
                            setAutosaveStatus('error');
                        } else {
                            console.error("Unexpected SE_NUMBER_EXISTS conflict during update for SE:", currentSeNo, errorResult.message);
                            notification.error({ message: 'Autosave Error', description: `Gagal menyimpan data otomatis: ${errorResult.message}`, duration: 3 });
                            setAutosaveStatus('error');
                        }
                        return;
                    } else {
                        throw new Error(errorResult.message || 'Conflict occurred');
                    }
                } else {
                    const errorData = await response.json();
                    throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
                }
            } catch (error: any) {
                notification.error({ message: 'Autosave Error', description: `Gagal menyimpan data secara otomatis: ${error.message}`, duration: 3 });
                setAutosaveStatus('error');
            }
        },
        [setAutosaveStatus, lastSavedState, form, userData, backendUrl, notification, isEqual]
    );

    const debouncedAutosave = useMemo(
        () =>
            debounce((formVals, tableDataVals, isEditing) => {
                autosave(formVals, tableDataVals, isEditing);
            }, 1500),
        [autosave]
    );

    const handleFormChange = () => {
        if (!isAutosaveEnabled) return;
        const currentValues = form.getFieldsValue();
        if (currentValues.status === 'Draft' || currentValues.status === '01') {
            debouncedAutosave(currentValues, tableData, isActuallyEditing);
        }
    };

    useEffect(() => {
        if (!isAutosaveEnabled) {
            setAutosaveStatus('stopped');
            debouncedAutosave.cancel();
            return;
        }


        const currentSeNo = seNoWatch;
        const currentStatus = statusWatch;
        const currentOrderType = orderTypeWatch;

        if (!currentSeNo || currentStatus !== 'Draft' || (!isActuallyEditing && !currentOrderType)) {
            setAutosaveStatus('stopped');
            debouncedAutosave.cancel();
            return;
        }

        if (!isEqual(tableData, lastSavedState.current.tableData)) {
            debouncedAutosave(form.getFieldsValue(), tableData, isActuallyEditing);
        }

        return () => {
            debouncedAutosave.cancel();
        };
    }, [seNoWatch, statusWatch, orderTypeWatch, tableData, isAutosaveEnabled, isActuallyEditing, debouncedAutosave, form]);

    useEffect(() => {
        const currentTop = topWatch;
        const creditLimitRemaining = Number(creditLimitWatch || 0);
        const grandTotal = Number(grandTotalWatch || 0);
        const isCreditLimitExceeded = currentTop !== 'COD' && grandTotal > creditLimitRemaining;
        if (isActuallyEditing) {
            if (isCreditLimitExceeded) {
                notification.warning({
                    key: 'creditLimitWarning',
                    message: 'Peringatan Kredit Limit',
                    description: `Grand Total (${grandTotal.toLocaleString('id-ID')}) melebihi Sisa Kredit Limit (${creditLimitRemaining.toLocaleString('id-ID')}). Harap perhatikan!`,
                    duration: 0,
                });
            } else {

                notification.destroy('creditLimitWarning');
            }
        } else {
            notification.destroy('creditLimitWarning');
        }

    }, [isActuallyEditing, form, topWatch, creditLimitWatch, grandTotalWatch]);


    const getNamaWilayah = (kode: string, type: 'provinsi' | 'kabupaten' | 'kecamatan' | 'kelurahan') => {
        switch (type) {
            case 'provinsi': return provinsiData?.find((p: Provinsi) => p.kode_provinsi === kode)?.nama_provinsi || kode;
            case 'kabupaten': return kabupatenData?.find((k: Kabupaten) => k.kode_dati === kode)?.deskripsi_kode_dati || kode;
            case 'kecamatan': return kecamatanData?.find((k: Kecamatan) => k.kode_kecamatan === kode)?.deskripsi_kode_kecamatan || kode;
            case 'kelurahan': return kelurahanData?.find((k: Kelurahan) => k.kode_kelurahan === kode)?.deskripsi_kode_kelurahan || kode;
            default:
                return kode;
        }
    };

    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return {
            display: `${day}/${month}/${year}`,
            value: `${year}-${month}-${day}`
        };
    };


    const handleCustomerCodeBlur = async () => {
        const customerCode = form.getFieldValue('cs_code');
        if (!customerCode) return;

        try {
            const customers = await fetchCustomerList();
            const customer = customers.find((c: any) => c.cs_code === customerCode);

            if (customer) {
                if (customer.record_status === '2') {
                    notification.warning({ message: 'Peringatan', description: 'Data telah dinonaktifkan hubungi Admin!' });
                    form.setFieldsValue({
                        cs_name: '',
                        title_prefix: '',
                        customer_name: '',
                        title_suffix: '',
                        cs_address1: '',
                        cs_address2: '',
                        cs_provinsi: '',
                        cs_kabupaten: '',
                        cs_kecamatan: '',
                        cs_kelurahan: '',
                        cs_kodepos: '',
                        cs_phone: '',
                        cs_phone1: '',
                        cs_npwp: ''
                    });
                    setCustomerData(null);
                    setIsCheckedCustomerDetail(false);
                } else {

                    setCustomerData(customer);

                    form.setFieldsValue({
                        cs_name: customer.cs_name,
                    });


                    form.setFieldsValue({
                        title_prefix: customer.title_p,
                        customer_name: customer.cs_name,
                        title_suffix: customer.title_s,
                        cs_address1: customer.address_line1,
                        cs_address2: customer.address_line2,
                        cs_provinsi: getNamaWilayah(customer.provinsi, 'provinsi'),
                        cs_kabupaten: getNamaWilayah(customer.kabupaten, 'kabupaten'),
                        cs_kecamatan: getNamaWilayah(customer.kecamatan, 'kecamatan'),
                        cs_kelurahan: getNamaWilayah(customer.kelurahan, 'kelurahan'),
                        cs_kodepos: customer.kode_pos,
                        cs_phone: customer.no_hp1,
                        cs_phone1: customer.no_hp2,
                        cs_npwp: customer.vatnpwp
                    });
                }
            } else {
                setCustomerData(null);
                notification.warning({ message: 'Peringatan', description: 'Customer not found' });
                form.setFieldsValue({
                    cs_name: '',
                    title_prefix: '',
                    customer_name: '',
                    title_suffix: '',
                    cs_address1: '',
                    cs_address2: '',
                    cs_provinsi: '',
                    cs_kabupaten: '',
                    cs_kecamatan: '',
                    cs_kelurahan: '',
                    cs_kodepos: '',
                    cs_phone: '',
                    cs_phone1: '',
                    cs_npwp: ''
                });
            }
        } catch (error) {
            console.error('Error fetching customer:', error);
            notification.error({ message: 'Error', description: 'Failed to fetch customer data' });
        }
    };


    const handleCustomerModalOpen = () => {
        setIsCustomerModalVisible(true);
    };
    const handleCustomerModalClose = () => {
        setIsCustomerModalVisible(false);
    };
    const handleCustomerSelect = (customer: any) => {
        if (customer.record_status === '2') {
            notification.warning({ message: 'Peringatan', description: 'Data telah dinonaktifkan hubungi Admin!' });
            form.setFieldsValue({
                cs_code: '',
                cs_name: '',
                title_prefix: '',
                customer_name: '',
                title_suffix: '',
                cs_address1: '',
                cs_address2: '',
                cs_provinsi: '',
                cs_kabupaten: '',
                cs_kecamatan: '',
                cs_kelurahan: '',
                cs_kodepos: '',
                cs_phone: '',
                cs_phone1: '',
                cs_npwp: ''
            });
            setCustomerData(null);
            setIsCheckedCustomerDetail(false);
            setIsCustomerModalVisible(false);
        } else {
            const remainingCredit = Number(customer.remaining_credit_limit || 0);
            const creditLimit = Number(customer.credit_limit || 0);

            const applyCustomerData = () => {
                setCustomerData(customer);
                form.setFieldsValue({
                    cs_code: customer.cs_code,
                    cs_name: customer.cs_name,
                    title_prefix: customer.title_p,
                    customer_name: customer.cs_name,
                    title_suffix: customer.title_s,
                    cs_address1: customer.address_line1,
                    cs_address2: customer.address_line2,
                    cs_provinsi: getNamaWilayah(customer.provinsi, 'provinsi'),
                    cs_kabupaten: getNamaWilayah(customer.kabupaten, 'kabupaten'),
                    cs_kecamatan: getNamaWilayah(customer.kecamatan, 'kecamatan'),
                    cs_kelurahan: getNamaWilayah(customer.kelurahan, 'kelurahan'),
                    cs_kodepos: customer.kode_pos,
                    cs_phone: customer.no_hp1,
                    cs_phone1: customer.no_hp2,
                    cs_npwp: customer.vatnpwp,
                    credit_limit_approval_status: customer.credit_limit,
                    credit_limit_remaining: customer.remaining_credit_limit
                });
                if (isCheckedSameID) {
                    form.setFieldsValue({
                        delivery_address1: customer.address_line1,
                        delivery_address2: customer.address_line2,
                        contact_person: customer.no_hp1,
                        contact_phone: customer.no_hp2
                    });
                }
                setIsCustomerModalVisible(false);
            };

            const clearCustomerFieldsAndCloseModal = () => {
                form.setFieldsValue({
                    cs_code: '',
                    cs_name: '',
                    title_prefix: '',
                    customer_name: '',
                    title_suffix: '',
                    cs_address1: '',
                    cs_address2: '',
                    cs_provinsi: '',
                    cs_kabupaten: '',
                    cs_kecamatan: '',
                    cs_kelurahan: '',
                    cs_kodepos: '',
                    cs_phone: '',
                    cs_phone1: '',
                    cs_npwp: '',
                    credit_limit_approval_status: '',
                    credit_limit_remaining: 0,
                    delivery_address1: '',
                    delivery_address2: '',
                    contact_person: '',
                    contact_phone: ''
                });
                setCustomerData(null);
                setIsCheckedCustomerDetail(false);
                setIsCustomerModalVisible(false);
            };

            if (remainingCredit < creditLimit) {
                Modal.confirm({
                    title: 'Peringatan Kredit Limit',
                    content: 'Credit limit sudah melewati batas harap perhatikan Customer !',
                    okText: 'Lanjutkan',
                    cancelText: 'Batal',
                    onOk: () => {
                        applyCustomerData();
                    },
                    onCancel: () => {
                        clearCustomerFieldsAndCloseModal();
                    },
                });
            } else {
                applyCustomerData();
            }
        }
    };


    const handleSearch = (
        selectedKeys: string[],
        confirm: FilterDropdownProps['confirm'],
        dataIndex: keyof SalesMasterData,
    ) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters: () => void) => {
        clearFilters();
        setSearchText('');
    };
    const getColumnSearchProps = (dataIndex: keyof SalesMasterData): TableColumnType<SalesMasterData> => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Reset
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({ closeDropdown: false });
                            setSearchText((selectedKeys as string[])[0]);
                            setSearchedColumn(dataIndex);
                        }}
                    >
                        Filter
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            close();
                        }}
                    >
                        Close
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered: boolean) => (
            <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]?.toString()
                .toLowerCase()
                .includes((value as string).toLowerCase()) ?? false,
        filterDropdownProps: {
            onOpenChange: (visible) => {
                if (visible) {
                    setTimeout(() => searchInput.current?.select(), 100);
                }
            },
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    const AvailableQtyCell: React.FC<{ itemCode: string; warehouse: string }> = ({ itemCode, warehouse }) => {
        const backendUrl = process.env.REACT_APP_BACKEND_URL;
        const { data } = useSWR(itemCode && warehouse ? `${backendUrl}/api/spareparts-sales?item_code=${itemCode}&warehouse_code=${warehouse}` : null, async (url: string) => {
            const res = await fetch(url);
            return res.json();
        }, { refreshInterval: 5000 });
        const stock = data?.data?.[0]?.qty ?? 0;
        return <span>{stock}</span>;
    };

    const StatusPartCell: React.FC<{ itemCode: string; warehouse: string; dmd: number; sup: number }> = ({ itemCode, warehouse, dmd, sup }) => {
        const backendUrl = process.env.REACT_APP_BACKEND_URL;
        const { data } = useSWR(itemCode && warehouse ? `${backendUrl}/api/spareparts-sales?item_code=${itemCode}&warehouse_code=${warehouse}` : null, async (url: string) => {
            const res = await fetch(url);
            return res.json();
        }, { refreshInterval: 5000 });
        const avail = data?.data?.[0]?.qty ?? 0;
        let statusPart = '01';
        if (avail >= dmd && sup === dmd && dmd > 0) { statusPart = '07'; }
        else if (avail >= dmd && (!sup || sup === 0)) { statusPart = '06'; }
        else if (avail === 0 && (!sup || sup === 0)) { statusPart = '02'; }
        else if (avail < dmd && (!sup || sup === 0)) { statusPart = '04'; }
        let color = ''; let text = '';
        switch (statusPart) {
            case '01': color = 'green'; text = 'Ready'; break;
            case '02': color = 'red'; text = 'Not Available'; break;
            case '04': color = 'blue'; text = 'Not Enough'; break;
            case '06': color = 'orange'; text = 'Ready Picking'; break;
            case '07': color = 'cyan'; text = 'Complete'; break;
            default: color = 'default'; text = statusPart; break;
        }
        return <Tag color={color}>{text}</Tag>;
    };

    const columns: TableColumnsType<SalesMasterData> = [
        {
            title: 'Status Part',
            dataIndex: 'status_part',
            key: 'status_part',
            render: (_, record) => <StatusPartCell itemCode={record.item_code} warehouse={record.warehouse_group || ''} dmd={record.dmd} sup={record.sup} />,
            sorter: (a, b) => a.status_part.localeCompare(b.status_part),
            sortDirections: ['ascend', 'descend'],
        },
        {
            title: 'PR No',
            dataIndex: 'pr_no',
            key: 'pr_no',
            ...getColumnSearchProps('pr_no'),
            sorter: (a, b) => (a.pr_no || '').localeCompare(b.pr_no || ''),
            sortDirections: ['ascend', 'descend'],
        },
        {
            title: 'Item Code',
            dataIndex: 'item_code',
            key: 'item_code',
            ...getColumnSearchProps('item_code'),
            sorter: (a, b) => (a.item_code?.toString() || '').localeCompare(b.item_code?.toString() || ''),
            sortDirections: ['ascend', 'descend'],
        },
        {
            title: 'Item Name',
            dataIndex: 'item_name',
            key: 'item_name',
            ...getColumnSearchProps('item_name'),
            sorter: (a, b) => (a.item_name || '').localeCompare(b.item_name || ''),
            sortDirections: ['ascend', 'descend'],
        },
        {
            title: 'Subs',
            dataIndex: 'subs',
            key: 'subs',
            ...getColumnSearchProps('subs'),
            sorter: (a, b) => (a.subs || '').localeCompare(b.subs || ''),
            sortDirections: ['ascend', 'descend'],
        },
        {
            title: 'UOM',
            dataIndex: 'uom',
            key: 'uom',
            ...getColumnSearchProps('uom'),
            sorter: (a, b) => (a.uom || '').localeCompare(b.uom || ''),
            sortDirections: ['ascend', 'descend'],
        },
        {
            title: 'Qty',
            children: [
                {
                    title: 'DMD',
                    dataIndex: 'dmd',
                    key: 'dmd',
                    ...getColumnSearchProps('dmd'),
                    align: 'center',
                    sorter: (a, b) => (a.dmd || 0) - (b.dmd || 0),
                    sortDirections: ['ascend', 'descend'],
                },
                {
                    title: 'SUP',
                    dataIndex: 'sup',
                    key: 'sup',
                    ...getColumnSearchProps('sup'),
                    align: 'center',
                    sorter: (a, b) => (a.sup || 0) - (b.sup || 0),
                    sortDirections: ['ascend', 'descend'],
                }
            ]
        },
        {
            title: 'Available Quantity',
            dataIndex: 'available_qty',
            key: 'available_qty',
            ...getColumnSearchProps('available_qty'),
            sorter: (a, b) => (a.available_qty || 0) - (b.available_qty || 0),
            sortDirections: ['ascend', 'descend'],
            render: (_, record) => <AvailableQtyCell itemCode={record.item_code} warehouse={record.warehouse_group || ''} />,
        },
        {
            title: 'Price',
            dataIndex: 'price',
            key: 'price',
            ...getColumnSearchProps('price'),
            sorter: (a, b) => (a.price || 0) - (b.price || 0),
            sortDirections: ['ascend', 'descend'],
            render: (value) => value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '',
        },
        {
            title: 'Original Disc. (%)',
            dataIndex: 'original_disc_percent',
            key: 'original_disc_percent',
            ...getColumnSearchProps('original_disc_percent'),
            sorter: (a, b) => (a.original_disc_percent || 0) - (b.original_disc_percent || 0),
            sortDirections: ['ascend', 'descend'],
        },
        {
            title: 'Original Disc. Amount',
            dataIndex: 'original_disc_amount',
            key: 'original_disc_amount',
            ...getColumnSearchProps('original_disc_amount'),
            sorter: (a, b) => (a.original_disc_amount || 0) - (b.original_disc_amount || 0),
            sortDirections: ['ascend', 'descend'],
            render: (value) => value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '',
        },
        {
            title: 'Proposal Disc. (%)',
            dataIndex: 'proposal_disc_percent',
            key: 'proposal_disc_percent',
            ...getColumnSearchProps('proposal_disc_percent'),
            sorter: (a, b) => (a.proposal_disc_percent || 0) - (b.proposal_disc_percent || 0),
            sortDirections: ['ascend', 'descend'],
        },
        {
            title: 'Proposal Disc. Amount',
            dataIndex: 'proposal_disc_amount',
            key: 'proposal_disc_amount',
            ...getColumnSearchProps('proposal_disc_amount'),
            sorter: (a, b) => (a.proposal_disc_amount || 0) - (b.proposal_disc_amount || 0),
            sortDirections: ['ascend', 'descend'],
            render: (value) => value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '',
        },
        {
            title: 'Total',
            dataIndex: 'total',
            key: 'total',
            ...getColumnSearchProps('total'),
            sorter: (a, b) => (a.total || 0) - (b.total || 0),
            sortDirections: ['ascend', 'descend'],
            render: (value) => value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '',
        },
        {
            title: 'Chassis No',
            dataIndex: 'chassis_no',
            key: 'chassis_no',
            ...getColumnSearchProps('chassis_no'),
            sorter: (a, b) => (a.chassis_no || '').localeCompare(b.chassis_no || ''),
            sortDirections: ['ascend', 'descend'],
        },
        {
            title: 'Regional Stock',
            dataIndex: 'regional_stock',
            key: 'regional_stock',
            ...getColumnSearchProps('regional_stock'),
            sorter: (a, b) => (a.regional_stock || '').localeCompare(b.regional_stock || ''),
            sortDirections: ['ascend', 'descend'],
        },
        {
            title: 'Invoice Return no',
            dataIndex: 'invoice_return_no',
            key: 'invoice_return_no',
            ...getColumnSearchProps('invoice_return_no'),
            sorter: (a, b) => (a.invoice_return_no || '').localeCompare(b.invoice_return_no || ''),
            sortDirections: ['ascend', 'descend'],
        },
    ];


    const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
        setSelectedRowKeys(newSelectedRowKeys);

        const selectedRows = tableData.filter(item =>
            newSelectedRowKeys.includes(item.key as React.Key)
        );

        const hasReadyStatus = selectedRows.some(row => row.status_part === '01');
        setIsReadyButtonDisabled(hasReadyStatus);

        const hasNonReadyItems = selectedRows.some(row => row.status_part !== '01');
        setIsReadyButtonDisabled(!hasNonReadyItems);

        const allNotAvailable = selectedRows.every(row => row.status_part === '02');
        setIsNotAvailableButtonDisabled(allNotAvailable);

        const soNoValue = form.getFieldValue('so_no');
        const hasSoNo = !!soNoValue;
        const hasSelectedItems = newSelectedRowKeys.length > 0;
        const allSelectedHaveAvailableQty = selectedRows.every(row => (row.available_qty || 0) > 0);
        const hasLockedOrRequestedItems = selectedRows.some(row => row.status_part === '03' || row.status_part === '04');
        setIsLockItemDisabled(!(hasSoNo && hasSelectedItems && allSelectedHaveAvailableQty && !hasLockedOrRequestedItems));
    };

    const handleNotAvailable = () => {
        const updatedData = tableData.map(item =>
            selectedRowKeys.includes(item.key as React.Key)
                ? { ...item, status_part: '02' }
                : item
        );
        setTableData(updatedData);
        setSelectedRowKeys([]);
        notification.success({ message: 'Sukses', description: 'Item marked as Not Available' });
    };

    const handleReady = () => {
        const updatedData = tableData.map(item =>
            selectedRowKeys.includes(item.key as React.Key) && item.status_part !== '01'
                ? { ...item, status_part: '01' }
                : item
        );
        setTableData(updatedData);
        setSelectedRowKeys([]);
        notification.success({ message: 'Sukses', description: 'Selected items marked as Ready' });
    };

    const handleLockItem = async () => {
        if (selectedRowKeys.length === 0) {
            notification.warning({ message: 'Peringatan', description: 'Pilih item yang ingin dilock terlebih dahulu' });
            return;
        }

        const selectedRows = tableData.filter(item =>
            selectedRowKeys.includes(item.key as React.Key)
        );

        const allSelectedHaveAvailableQty = selectedRows.every(row => (row.available_qty || 0) > 0);
        if (!allSelectedHaveAvailableQty) {
            notification.warning({ message: 'Peringatan', description: 'Semua item yang dipilih harus memiliki Available Quantity > 0 untuk dilock.' });
            return;
        }

        if (!userData || !userData.kode_grup1 || !userData.warehouse_code) {
            notification.error({ message: 'Error', description: 'Data user tidak lengkap. Tidak dapat melakukan lock item.' });
            return;
        }

        const itemsToLock = selectedRows.map(item => ({
            item_code: item.item_code,
            qty: item.dmd,
        }));

        const itemCodesToLock = itemsToLock.map(item => item.item_code);
        const seNo = form.getFieldValue('se_no');
        const soNoValue = form.getFieldValue('so_no');

        if (!soNoValue) {
            notification.error({ message: 'Error', description: 'SO Number harus terisi untuk Lock Item.' });
            return;
        }

        if (!seNo) {
            notification.error({ message: 'Error', description: 'Harap simpan SE terlebih dahulu untuk Lock Item.' });
            return;
        }

        try {

            const confirmResult = await new Promise((resolve) => {
                Modal.confirm({
                    title: 'Konfirmasi Lock Item',
                    content: 'Apakah Anda yakin ingin mengunci item yang dipilih?',
                    okText: 'Ya',
                    cancelText: 'Tidak',
                    onOk: () => resolve(true),
                    onCancel: () => resolve(false),
                });
            });

            if (!confirmResult) {
                notification.info({ message: 'Informasi', description: 'Lock item dibatalkan.' });
                return;
            }

            const response = await fetch(`${backendUrl}/api/lock-sales-items`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                },
                body: JSON.stringify({
                    se_no: seNo,
                    itemCodes: itemCodesToLock,
                })
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Gagal mengirim lock item request');
            }

            const updatedData = tableData.map(item =>
                selectedRowKeys.includes(item.key as React.Key)
                    ? { ...item, status_part: '04' }
                    : item
            );
            setTableData(updatedData);
            setSelectedRowKeys([]);
            notification.success({ message: 'Sukses', description: 'Item berhasil dilock dan ditambahkan ke prioritas' });

        } catch (error) {
            console.error('Error locking item:', error);
            notification.error({ message: 'Error', description: 'Gagal melakukan lock item: ' + (error instanceof Error ? error.message : 'Unknown error') });
        }
    };

    const handleCustomerDetail = () => setIsCheckedCustomerDetail(prev => !prev);
    const handleSameID = () => {
        setIsCheckedSameID(prev => !prev);
        setShouldUpdateFields(true);
    };
    useEffect(() => {
        if (shouldUpdateFields) {
            if (isCheckedSameID && customerData) {

                form.setFieldsValue({
                    delivery_address1: customerData.address_line1,
                    delivery_address2: customerData.address_line2,
                    contact_person: customerData.no_hp1,
                    contact_phone: customerData.no_hp2
                });
            } else {

                form.setFieldsValue({
                    delivery_address1: '',
                    delivery_address2: '',
                    contact_person: '',
                    contact_phone: ''
                });
            }
            setShouldUpdateFields(false);
        }
    }, [isCheckedSameID, customerData, shouldUpdateFields, form]);


    const rowSelection: TableProps<SalesMasterData>['rowSelection'] = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    const handleDeliverViaChange: SelectProps['onChange'] = (value: string) => {
        setDeliverVia(value);
    };
    const deliverViaOptions = [
        { value: "", label: "-- Empty --" },
        ...deliverViaData.map(item => ({
            value: item.code,
            label: `${item.deskripsi}`
        }))
    ];

    const handleWarehouseGroupChange: SelectProps['onChange'] = (value: string) => {
        setWarehouseGroup(value);
    };

    const warehouseGroupOptions = [
        { value: "", label: "-- Empty --" },
        ...warehouseData
            .filter(item =>
                !userData?.warehouse_code || item.warehouse_code === userData.warehouse_code
            )
            .map(item => ({
                value: item.warehouse_code,
                label: `${item.warehouse_name}`
            }))
    ];


    const handleOutstandingRemarkChange: SelectProps['onChange'] = (value: string) => {
        setOutstandingRemark(value);
    };
    const outstandingRemarkOptions = [
        { value: "", label: "-- Empty --" },
        ...outstandingRemarkData.map(item => ({
            value: item.code,
            label: `${item.deskripsi}`
        }))
    ];


    const handleOrderTypeChange: SelectProps['onChange'] = (value: string) => {
        if (value === "" && orderType !== "") {
            form.setFieldsValue({ order_type: orderType });
            return;
        }

        setOrderType(value);
        const currentSeNo = form.getFieldValue('se_no');
        if (value && !currentSeNo) {
            generateNewSENumber().then(() => {
                const updatedValues = form.getFieldsValue();
                if (updatedValues.se_no) {
                    setAutosaveStatus('processing');
                    debouncedAutosave(updatedValues, tableData, isActuallyEditing);
                }
            });
        }
    };
    const orderTypeOptions = [
        { value: "", label: "-- Empty --" },
        ...orderTypeData.map(item => ({
            value: item.code,
            label: `${item.deskripsi}`
        }))
    ];


    const handleTopChange: SelectProps['onChange'] = (value: string) => {
        setTop(value);
    };
    const TopOptions = [
        { value: "", label: "-- Empty --" },
        ...topData.map(item => ({
            value: item.code,
            label: `${item.deskripsi}`
        }))
    ];


    const handleTransTypeChange: SelectProps['onChange'] = (value: string) => {
        setTransType(value);
    };
    const transTypeOptions = [
        { value: "", label: "-- Empty --" },
        ...transactionTypeData.map(item => ({
            value: item.code,
            label: `${item.deskripsi}`
        }))
    ];

    const handlePrint = async () => {
        const seNoValue = form.getFieldValue('se_no');
        if (!seNoValue) {
            notification.warning({ message: 'Peringatan', description: 'Sales Estimation No. tidak ditemukan.' });
            return;
        }

        setIsPrinting(true);
        const key = 'print_progress_notification';
        const updateProgress = (percent: number) => {
            notification.info({
                key,
                message: 'Mempersiapkan Dokumen',
                description: <Progress percent={percent} status="active" />,
                duration: 0,
                placement: 'topRight',
            });
        };

        try {
            updateProgress(0);
            const response = await fetch(`${backendUrl}/api/sales-export?se_no=${encodeURIComponent(seNoValue)}`);
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Gagal mengambil data laporan');
            }
            const reportData = await response.json();
            const header = reportData.header;

            if (!header) {
                notification.error({ message: 'Error', description: 'Data Sales Estimation tidak ditemukan untuk nomor ini.' });
                return;
            }

            updateProgress(40);
            const duration = 1000;
            const interval = 100;
            const steps = duration / interval;
            const increment = (100 - 40) / steps;
            let currentPercent = 40;

            for (let i = 0; i < steps; i++) {
                await new Promise(resolve => setTimeout(resolve, interval));
                currentPercent += increment;
                updateProgress(Math.round(currentPercent));
            }

            const now = new Date();
            const docDate = `${String(now.getDate()).padStart(2, '0')}/${String(now.getMonth() + 1).padStart(2, '0')}/${now.getFullYear()}`;
            let docNo = '';
            let reportTitle = 'SALES ESTIMATION';

            if (header.status !== '01' && header.status !== 'Draft') {
                reportTitle = 'SALES ORDER';
            }

            if (header.status === '02' || header.status === 'Approved') {
                docNo = header.so_no;
            } else {
                docNo = header.se_no;
            }

            const totalNetPriceSum = reportData.items.reduce((sum: number, item: any) => sum + (Number(item.total) || 0), 0);
            const calculatedVAT = totalNetPriceSum * (ppn / 100);
            const calculatedGrandTotal = totalNetPriceSum + calculatedVAT;

            const warehouseMapping: Record<string, string> = {
                'WH_AMP_PBUN': 'Pangkalanbun',
                'WH_AMP_PKY': 'Palangkaraya',
                'WH_AMP_SPT': 'Sampit',
                'WH_AMP_TWH': 'Teweh'
            };
            const warehouseConverted = warehouseMapping[header.warehouse_group] || null;

            const reportPayload = {
                Header: [{
                    se_no: header.se_no || "",
                    so_no: header.so_no || "",
                    sales_date: header.sales_date || "",
                    doc_no: docNo,
                    doc_date: docDate,
                    report_title: reportTitle,
                    cs_code: header.cs_code || "",
                    cs_name: header.cs_name || "",
                    customer_address1: header.customer_address1 || "",
                    customer_address2: header.customer_address2 || "",
                    customer_npwp: header.customer_npwp || "",
                    order_type_desc: header.order_type_desc || header.order_type || "",
                    purchase_order_no: header.purchase_order_no || "",
                    top_desc: header.top_desc || header.top || "",
                    deliver_via_desc: header.deliver_via_desc || header.deliver_via || "",
                    delivery_address1: header.delivery_address1 || "",
                    delivery_address2: header.delivery_address2 || "",
                    trans_type_desc: header.trans_type_desc || header.trans_type || "",
                    salesman_name: header.salesman_name || header.sales_person || "",
                    contact_phone: header.contact_phone || "",
                    contact_person: header.contact_person || "",
                    warehouse: warehouseConverted,
                    sub_total: totalNetPriceSum,
                    vat: calculatedVAT,
                    grand_total: calculatedGrandTotal
                }],
                Details: reportData.items.map((item: any, index: number) => {
                    const totalPrice = (Number(item.price) || 0) * (Number(item.dmd) || 0);
                    let discPercentText = '0%';
                    let discAmountVal = 0;
                    if (item.original_disc_percent > 0 || item.original_disc_amount > 0) {
                        discPercentText = `${item.original_disc_percent || 0}%`;
                        discAmountVal = Number(item.original_disc_amount) || 0;
                    } else if (item.proposal_disc_percent > 0 || item.proposal_disc_amount > 0) {
                        discPercentText = `${item.proposal_disc_percent || 0}%`;
                        discAmountVal = Number(item.proposal_disc_amount) || 0;
                    }
                    return {
                        no: index + 1,
                        item_code: item.item_code || "",
                        item_name: item.item_name || "",
                        dmd: Number(item.dmd) || 0,
                        uom: item.uom || "",
                        price: Number(item.price) || 0,
                        total_price: totalPrice,
                        disc_percent: discPercentText,
                        disc_amount: discAmountVal,
                        net_price: Number(item.total) || 0
                    };
                })
            };
            await import("stimulsoft-reports-js/Css/stimulsoft.viewer.office2013.whiteblue.css");
            await import("stimulsoft-reports-js/Scripts/stimulsoft.reports");
            const viewerModule = await import("stimulsoft-reports-js/Scripts/stimulsoft.viewer");
            const Stimulsoft = viewerModule.Stimulsoft || (window as any).Stimulsoft;
            StartLicense(Stimulsoft);
            setIsReportModalOpen(true);
            setTimeout(() => {
                const report = Stimulsoft.Report.StiReport.createNewReport();
                report.loadFile("/reports/SE/sales_order.mrt");
                const dataSet = new Stimulsoft.System.Data.DataSet("ReportData");
                dataSet.readJson(reportPayload);
                report.regData(dataSet.dataSetName, "", dataSet);
                report.dictionary.synchronize();
                const options = new Stimulsoft.Viewer.StiViewerOptions();
                options.toolbar.showOpenButton = true;
                const viewer = new Stimulsoft.Viewer.StiViewer(options, "StiViewer", false);
                (viewer as any).onOpenReport = (args: any) => {
                    const newReport = args.report;
                    if (newReport) {
                        newReport.regData(dataSet.dataSetName, "", dataSet);
                        newReport.dictionary.synchronize();
                        viewer.report = newReport;
                    }
                };
                viewer.report = report;
                viewer.renderHtml("sti-viewer-container");
            }, 300);

        } catch (error: any) {
            console.error('Error generating print report:', error);
            notification.error({ message: 'Error', description: `Gagal mencetak laporan: ${error.message}` });
            setIsPrinting(false);
        } finally {
            setIsPrinting(false);
            notification.destroy(key);
        }
    };

    useEffect(() => {
        const seNoValue = seNoWatch;
        setIsPrintButtonDisabled(!seNoValue || autosaveStatus === 'processing');
    }, [form, seNoWatch, autosaveStatus]);

    useEffect(() => {
        const handleBeforeUnload = (e: BeforeUnloadEvent) => {
            if (autosaveStatus === 'processing') {
                e.preventDefault();
                e.returnValue = '';
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [autosaveStatus]);




    return {
        selectedRowKeys,
        isCheckedCustomerDetail,
        isCheckedSameID,
        handleCustomerDetail,
        handleSameID,
        rowSelection,
        deliverVia,
        handleDeliverViaChange,
        deliverViaOptions,
        warehouseGroup,
        handleWarehouseGroupChange,
        warehouseGroupOptions,
        outstandingRemark,
        handleOutstandingRemarkChange,
        outstandingRemarkOptions,
        orderType,
        handleOrderTypeChange,
        orderTypeOptions,
        Top,
        handleTopChange,
        handleTransTypeChange,
        transTypeOptions,
        transType,
        searchText,
        searchedColumn,
        TopOptions,
        tableData,
        loading: isLoadingTableData,
        error: tableDataError,
        columns,
        form,
        isCustomerModalVisible,
        handleCustomerModalOpen,
        handleCustomerModalClose,
        handleCustomerSelect,
        handleCustomerCodeBlur,
        customerData,
        shouldUpdateFields,
        getCurrentDate,
        handleNew,
        isAddLineModalVisible,
        handleAddLineModalOpen,
        handleAddLineModalClose,
        handleAddLineSubmit,
        handleRowDoubleClick,
        editingData,
        addLineModalKey,
        handleDelete,
        status,
        isStatus01,
        isEditMode,
        isReadyButtonDisabled,
        handleReady,
        handleNotAvailable,
        isNotAvailableButtonDisabled,
        handleCloseOrderModalOpen,
        handleCloseOrderModalClose,
        isCloseOrderModalVisible,
        setIsCloseOrderModalVisible,
        isCloseOrderDisabled,
        isSubmitDisabled,
        isVoidDisabled,
        handleSubmit,
        handleVoid,
        isAgreementModalVisible,
        handleAgreementModalOpen,
        handleAgreementModalClose,
        handleAgreementSelect,
        initialDiscForAddLine: currentAgreementDisc,
        overallLoading: loading,
        overallError: error,
        isActuallyEditing,
        isLockItemDisabled,
        handleLockItem,
        autosaveStatus,
        isPrintButtonDisabled,
        isPrinting,
        handlePrint,
        isReportModalOpen,
        handleReportModalCancel,
        handleFormChange,
        isSubmitModalVisible,
        submitRemark,
        setSubmitRemark,
        handleConfirmSubmit,
        handleSubmitModalClose
    };
};